import { render, staticRenderFns } from "./Date_Rated.vue?vue&type=template&id=1fafbd68&scoped=true"
import script from "./Date_Rated.vue?vue&type=script&lang=js"
export * from "./Date_Rated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fafbd68",
  null
  
)

export default component.exports